"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const FontAwesome = require("react-fontawesome");
class LoadableButton extends React.Component {
    render() {
        let content = React.createElement("span", null, this.props.text);
        let disabled = this.props.disable || false;
        if (this.props.isLoading) {
            content = React.createElement(FontAwesome, { name: "spinner", spin: true, fixedWidth: true });
            disabled = true;
        }
        return React.createElement(react_bootstrap_1.Button, { bsSize: this.props.bsSize || 'large', bsStyle: this.props.bsStyle, "data-cy": this.props['data-cy'], onClick: this.props.onClick, className: this.props.className, disabled: disabled }, content);
    }
}
exports.default = LoadableButton;


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/LoadableButton.tsx
// module id = 1060
// module chunks = 0 1 2